var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      {
        staticClass: "mailbox",
        class: { "is-open": _vm.isLeftSidebarVisible },
      },
      [
        _c("div", { staticClass: "mailbox-sidebar" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-theme btn-sm btn-block",
              attrs: { type: "button", disabled: _vm.taskListUpdating },
              on: { click: _vm.getAllTasks },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.taskListUpdating ? "Обновление..." : "Обновить") +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "sidebar-menu mt-0" },
            _vm._l(_vm.groups, function (group, alias) {
              return group.badge
                ? _c(
                    "li",
                    {
                      class: { active: _vm.selectedGroup === alias },
                      on: {
                        click: function ($event) {
                          return _vm.openGroup(alias)
                        },
                      },
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("i", { class: group.icon }),
                        _vm._v(
                          "\n          " + _vm._s(group.title) + "\n          "
                        ),
                        group.badge
                          ? _c(
                              "span",
                              { staticClass: "badge badge-pill badge-danger" },
                              [_vm._v(_vm._s(group.badge))]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "left-sidebar-btn",
              on: {
                click: function ($event) {
                  _vm.isLeftSidebarVisible = !_vm.isLeftSidebarVisible
                },
              },
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isLeftSidebarVisible,
                    expression: "!isLeftSidebarVisible",
                  },
                ],
                staticClass: "icon-fa icon-fa-angle-right",
              }),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLeftSidebarVisible,
                    expression: "isLeftSidebarVisible",
                  },
                ],
                staticClass: "icon-fa icon-fa-angle-left",
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mailbox-content" },
          [
            _c("pulse-loader", {
              staticClass: "text-center mt-5",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
            _vm._v(" "),
            !_vm.loading && _vm.selectedGroup
              ? _c("div", [
                  !_vm.displayTasks || !_vm.displayTasks.length
                    ? _c(
                        "div",
                        { staticClass: "alert alert-info m-2 text-center" },
                        [_c("p", [_vm._v("Активных задач не найдено")])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wrapCollapse" },
                    [
                      _vm.selectedGroup === "salaryCorrection"
                        ? [
                            _vm.displayTasks && _vm.displayTasks.length
                              ? _c("SalaryCorrection", {
                                  attrs: {
                                    list: _vm.displayTasks,
                                    removeRecord: (id) =>
                                      _vm.removeRecord(id, "salaryCorrection"),
                                  },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedGroup === "drugUpdate"
                        ? _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c("UpdateDrugStatusPrice", {
                                attrs: {
                                  tasks: _vm.displayTasks,
                                  updateTasksPull: () => _vm.getAllTasks(true),
                                },
                              }),
                            ],
                            1
                          )
                        : [
                            _c("table", { staticClass: "table table-hover" }, [
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.displayTasks, function (t, i) {
                                    return !_vm.hiddenSingleTasksTypes[
                                      t.type_id
                                    ]
                                      ? [
                                          _c(
                                            "tr",
                                            {
                                              staticClass: "read hover",
                                              class: {
                                                active: _vm.currentTask === i,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openTask(i)
                                                },
                                              },
                                            },
                                            [
                                              _vm._m(0, true),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "cell-content" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "content" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "content-name",
                                                        },
                                                        [
                                                          !_vm.hideNames
                                                            ? [
                                                                t.created_by
                                                                  ? _c(
                                                                      "UserName",
                                                                      {
                                                                        attrs: {
                                                                          id: t.created_by,
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _vm
                                                                  .usersForReply[
                                                                  t.id
                                                                ]
                                                                  ? [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " / "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm
                                                                        .usersForReply[
                                                                        t.id
                                                                      ].user
                                                                        .id !==
                                                                      t.created_by
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .usersForReply[
                                                                                    t
                                                                                      .id
                                                                                  ]
                                                                                    .user
                                                                                    .name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "( " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .$AllDivisions[
                                                                                  _vm
                                                                                    .usersForReply[
                                                                                    t
                                                                                      .id
                                                                                  ]
                                                                                    .division_id
                                                                                ]
                                                                                  ?.title
                                                                              ) +
                                                                              " )"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                              ]
                                                            : _vm._e(),
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "content-subject",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        (" +
                                                              _vm._s(
                                                                t.type_id
                                                              ) +
                                                              ") "
                                                          ),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.taskAlias[
                                                                  t.type_id
                                                                ]
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "badge badge-info",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  (
                                                                    t?.dialog
                                                                      ?.messages ??
                                                                    []
                                                                  ).length
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.getSmallTaskDescription(
                                                                t
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex flex_gap_10",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-muted",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(t.id)
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            t.sub_status
                                                              ? _c(
                                                                  "TasksSubStatuses",
                                                                  {
                                                                    attrs: {
                                                                      task: t,
                                                                      type: "display",
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "cell-time" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.printDate(
                                                        t.created_at
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", {
                                                staticClass: "cell-attachment",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.currentTask == i
                                            ? _c(
                                                "tr",
                                                { staticClass: "noHover" },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { colspan: "10" },
                                                    },
                                                    [
                                                      _c("GlobalTaskView", {
                                                        attrs: {
                                                          task: t,
                                                          getAllTasks:
                                                            _vm.getAllTasks,
                                                          groups: _vm.groups,
                                                          currentTask:
                                                            _vm.currentTask,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e()
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "cell-user" }, [
      _c("a", { staticClass: "user" }, [
        _c("img", {
          staticClass: "user-avatar",
          attrs: { src: "/assets/img/avatars/avatar.png" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }